<div class="d-flex justify-content-between mat-elevation-z4 p-2">
    <h4>
        Add application
    </h4>
    <button class="btn btn-outline-primary" routerLink="/admin/apps">
        Back to list
        <i class="bi bi-arrow-left"></i>
    </button>
</div>

<hr>
<div class="row" *ngIf="success">
    <div class="alert alert-success">
        Record has been created successfully
        <button class="btn btn-outline-success" routerLink="/admin/apps">Click to return</button>
    </div>
</div>
<div class="row mat-elevation-z4 p-2"> 
    <form class="col-md-8">
        <fieldset>
            <div class="mb-3">
                <label for="Id" class="form-label">Application Id</label>
                <input type="number" class="form-control" id="IdApplication" name="IdApplication"
                [(ngModel)]="App.IdApplication">
            </div>
            <div class="mb-3">
                <label for="Name" class="form-label">Application name</label>
                <input type="text" class="form-control" id="Name" name="Name"
                [(ngModel)]="App.ApplicationName">
            </div>
            <div class="mb-3">
                <label for="Description" class="form-label">Description</label>
                <input type="text" class="form-control" id="Description" name="Description"
                [(ngModel)]="App.Description">
            </div>
            <div class="mb-3">
                <label for="URL" class="form-label">URL</label>
                <input type="text" class="form-control" id="URL" name="URL"
                [(ngModel)]="App.Url">
            </div>

            <label for="Id" class="form-label">Environment</label>
            <div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="env" id="radioProd" [value]="true"
                        [(ngModel)]="App.Production">
                    <label class="form-check-label" for="radioProd">Production</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="env" id="radioTest" [value]="false"
                        [(ngModel)]="App.Production">
                    <label class="form-check-label" for="radioTest">Test</label>
                </div>
            </div>

            <label for="Id" class="form-label">Status</label>
            <div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="status" id="radioActive" [value]="true"
                        [(ngModel)]="App.Active">
                    <label class="form-check-label" for="radioActive">Active</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="status" id="radioDisabled" [value]="false"
                        [(ngModel)]="App.Active">
                    <label class="form-check-label" for="radioDisabled">Disabled</label>
                </div>
            </div>

            <label for="Id" class="form-label">Requires role</label>
            <div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="roleRequired" id="radioYesRole" [value]="true"
                        [(ngModel)]="App.RoleRequired">
                    <label class="form-check-label" for="radioYesRole">Yes</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="roleRequired" id="radioNoRole" [value]="false"
                        [(ngModel)]="App.RoleRequired">
                    <label class="form-check-label" for="radioNoRole">No</label>
                </div>
            </div>
        </fieldset>
    </form>
    <button class="btn btn-outline-success" *ngIf="!success" (click)="create()">
        Create
        <i class="bi bi-check-circle"></i>
    </button>
</div>